import type { IconSvgProps } from '../Icon.types';

export const TreebulaIcon = ({ width, height }: IconSvgProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 33 22">
      <path d="M23.4447 15.1313L31.1203 7.45567L26.8536 3.189L19.156 10.8646V0H13.1079V10.8426L5.45429 3.189L1.16564 7.45567L8.84124 15.1313H0V21.1794H9.89691C13.2399 21.1794 15.945 18.4742 15.945 15.1313H10.6887V14.7354C13.5918 14.7354 15.923 12.3821 15.923 9.50103H16.3189C16.3189 12.4041 18.6722 14.7354 21.5533 14.7354V15.1313H16.3409C16.3409 18.4742 19.046 21.1794 22.389 21.1794H32.2859V15.1313H23.4447Z" />
    </svg>
  );
};
